import "./src/styles/global.css";
import type { GatsbyBrowser } from "gatsby"


export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({
  location,
  prevLocation,
}) => {
  if (!prevLocation) return // first load is already counted by the script
  const w = window as any
  const _hsq = (w._hsq = w._hsq || [])
  _hsq.push(["setPath", location.pathname + location.search])
  _hsq.push(["trackPageView"])
}
